// Сайт без Telegram: сессия браузера вместо данных запуска Telegram.
// Новый посетитель получает пустого клиента на сервере; ссылка из письма (?k=…) — сессию этого клиента
// на любом устройстве. Хранится в localStorage; в приватном режиме — только на время вкладки.

import { inTelegram } from './tg.ts';

const KEY = 'vyd_session';
const BASE = (import.meta as any).env?.VITE_API_URL ?? '';
let memory: string | null = null;
let pending: Promise<string> | null = null;

/** Сайт открыт в обычном браузере (не в Telegram и не локальная разработка). */
export const onSite = !inTelegram && typeof location !== 'undefined' && location.hostname !== 'localhost';

function read(): string | null {
  try {
    return localStorage.getItem(KEY) ?? memory;
  } catch {
    return memory;
  }
}

function write(t: string) {
  memory = t;
  try {
    localStorage.setItem(KEY, t);
  } catch {
    /* приватный режим: живём в памяти вкладки */
  }
}

/** Ссылка из письма: забираем сессию и убираем её из адресной строки. */
export function takeLinkSession() {
  const q = new URLSearchParams(location.search);
  const k = q.get('k');
  if (!k) return;
  write(k);
  q.delete('k');
  const rest = q.toString();
  history.replaceState(null, '', location.pathname + (rest ? `?${rest}` : '') + location.hash);
}

export const hasSession = () => Boolean(read());
export const localSession = () => read() ?? '';

/** Токен сессии; при первом заходе сервер заводит клиента. */
export async function sessionToken(): Promise<string> {
  const t = read();
  if (t) return t;
  if (!pending) {
    pending = fetch(BASE + '/api/web/session', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
      .then(async (r) => {
        const data = await r.json().catch(() => ({}));
        if (!r.ok || !data.token) throw new Error(data.message ?? 'Не получилось открыть сайт, обнови страницу');
        write(data.token);
        return data.token as string;
      })
      .finally(() => {
        pending = null;
      });
  }
  return pending;
}

/** Сервер не узнал сессию (устарела): начинаем с новой. */
export function dropSession() {
  memory = null;
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ничего */
  }
}
